export const styles = {
  container: {
    padding: 2,
    paddingBottom: 10,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
  },
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
    color: 'error.main',
  },
  categorySection: {
    marginBottom: 3,
  },
  categoryTitle: {
    marginBottom: 2,
    fontWeight: 600,
  },
  productItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 2,
    marginBottom: 1,
    borderRadius: 1,
    backgroundColor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
  },
  productInfo: {
    display: 'flex',
    flexDirection: 'column' as const,
  },
  productName: {
    fontWeight: 500,
  },
  productUnit: {
    color: 'text.secondary',
    fontSize: '0.875rem',
  },
  productActions: {
    display: 'flex',
    gap: 1,
  },
  emptyState: {
    textAlign: 'center' as const,
    padding: 4,
    color: 'text.secondary',
  },
  addButtonContainer: {
    position: 'fixed' as const,
    bottom: 0,
    left: 0,
    right: 0,
    padding: 2,
    backgroundColor: 'background.paper',
    borderTop: '1px solid',
    borderColor: 'divider',
    zIndex: 1000,
  },
  addButton: {
    paddingY: 1.5,
  },
};